export enum SalesActionType {
  Set = 'sales/SET',
}
